import { faMinusSquare, faNoteSticky, faPlusSquare } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useState } from 'react';
import { formatDate } from '../../utils/dateHelper/dateHelper';
import './Note.scss';
import Modal from '../Modal/Modal';
import PropTypes from 'prop-types';
import DeleteNote from '../DeleteNote/DeleteNote';
import AddNote from '../AddNote/AddNote';

// Common Note Component
const Note = ({ note, number, refetchNotes, movementType, completed }) => {
  const [noteOpen, setNoteOpen] = useState();
  const [modalOpen, setModalOpen] = useState();

  const getModalContent = () => {
    switch (modalOpen) {
      case 'destroy':
        return (
          <DeleteNote noteId={note.id} refetchNotes={refetchNotes} setModalOpen={setModalOpen} />
        );
      case 'edit':
        return (
          <AddNote
            edit
            note={note}
            refetchNotes={refetchNotes}
            setModalOpen={setModalOpen}
            movementType={movementType}
          />
        );
    }
  };

  return (
    <>
      <div className="note_container">
        <div className="note_header" onClick={() => setNoteOpen(!noteOpen)}>
          <FontAwesomeIcon icon={faNoteSticky} className={'note_icon'} />
          <div className="note_type_number">
            Note #{number} : {note.noteType.name}
          </div>
          <FontAwesomeIcon
            icon={noteOpen ? faMinusSquare : faPlusSquare}
            className={noteOpen ? 'minus_icon' : 'plus_icon'}
            data-testid={noteOpen ? 'minus_icon' : 'plus_icon'}
          />
        </div>
        {noteOpen && (
          <div className="note_body">
            <div className="note_title">{note.title}</div>
            <div className="note_content">{note.content}</div>
            {!completed && (
              <div className="note_buttons">
                <button className="edit_button" onClick={() => setModalOpen('edit')}>
                  Edit
                </button>
                <button className="destroy_button" onClick={() => setModalOpen('destroy')}>
                  Destroy
                </button>
              </div>
            )}
            <div className="note_info">
              <div className="created_info">Created at {formatDate(note.createdAt)}</div>
              <div className="updated_info">Last updated at {formatDate(note.updatedAt)}</div>
            </div>
          </div>
        )}
      </div>
      {modalOpen && (
        <Modal
          title={modalOpen == 'edit' ? 'Edit Note' : ''}
          content={getModalContent()}
          setModalOpen={setModalOpen}
        />
      )}
    </>
  );
};

Note.propTypes = {
  note: PropTypes.object,
  number: PropTypes.number,
  refetchNotes: PropTypes.func,
  movementType: PropTypes.string,
  completed: PropTypes.bool,
};

export default Note;
